module.exports = __webpack_public_path__ + "img/vipevent_access_icon@2x.28b76173.png";